// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3614":"fc39d5fd","6612":"bb831f6e"}[chunkId] + ".chunk.css";
};